// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21878":"c9d09dac","40948":"9a669848"}[chunkId] + ".css";
};